/**
 * 用户意见管理
 */
export default {
  userFeedbackdetail: "/userFeedback/detail", //  详情/{id}
  userFeedbackpageList: "/userFeedback/pageList", //  分页查询
}
